import { useState, useEffect } from "react";
import { APIClient } from "../../../../../helpers/api_helper";
import { GET_SETTING_BY_NAME } from "../../../../../helpers/url_helper";

const apiClient = new APIClient();

export const useBankTokenization = () => {
  const [tokenizedBanks, setTokenizedBanks] = useState([]);
  const [loadingBanks, setLoadingBanks] = useState(true);

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        let { data } = await apiClient.get(GET_SETTING_BY_NAME, {
          name: "bank-tokenization",
        });

        setTokenizedBanks(data?.data.value ?? []);
      } catch (error) {
        console.error("Error al cargar bancos tokenizados:", error);
        setTokenizedBanks([]);
      } finally {
        setLoadingBanks(false);
      }
    };

    fetchBanks();
  }, []);

  return { tokenizedBanks, loadingBanks };
};
